import {initCopyLinkDelegation} from "../../../arivaGlobal/src/js/copyToClipboard";

export function initContactButtons() {
    initCopyLinkDelegation();

    document.querySelectorAll(".contact-item button").forEach((btn) => {
        btn.addEventListener("click", () => {
            const type = btn.dataset.type;
            const value = btn.dataset.value;
            const span = btn.nextElementSibling;

            if (span.classList.contains("d-none")) {
                if (type === "tel") {
                    span.innerHTML = `<a class="" href="tel:${value}"></i>${value}</a> <a href="javascript:void(0)" data-link="${value}" class="js-copyLink leadtext linkWithIcon"><i class="icon icon-copy"></i></a>`;
                } else if (type === "email") {
                    span.innerHTML = `<a class="" href="mailto:${value}"></i>${value}</a> <a href="javascript:void(0)" data-link="${value}" class="js-copyLink leadtext linkWithIcon"><i class="icon icon-copy"></i></a>`;
                }
                span.classList.remove("d-none");
                span.classList.add("d-flex");
                btn.closest(".contact-item").style.width = "100%";
            } else {
                span.innerHTML = "";
                span.classList.add("d-none");
                span.classList.remove("d-flex");
                btn.closest(".contact-item").style.width = "";
            }
        });
    });
}